var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup37001(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.09,
    height: 42.632,
    viewBox: "0 0 40.09 42.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bcc0cb;}.b{fill:#b9bdc7;}.c{fill:#fff;}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 40.09,
    height: 42.632,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.599 -293.659)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.289 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.576 293.378)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.217,6.309H25.168v.677a2.032,2.032,0,0,1-2.027,2.031H16.112a2.033,2.033,0,0,1-2.031-2.031V6.309H13.036A3.188,3.188,0,0,0,9.847,9.5V27.285a3.192,3.192,0,0,0,3.189,3.193H26.217a3.192,3.192,0,0,0,3.189-3.193V9.5A3.188,3.188,0,0,0,26.217,6.309ZM14.11,11.04a.8.8,0,0,1,.8-.8h9.432a.8.8,0,0,1,.8.8v1.271a.8.8,0,0,1-.8.8H14.908a.8.8,0,0,1-.8-.8Zm3.034,15.488a1.2,1.2,0,0,1-1.2,1.2H13.684a1.2,1.2,0,0,1-1.2-1.2V24.175a1.2,1.2,0,0,1,1.2-1.2H15.94a1.2,1.2,0,0,1,1.2,1.2Zm.109-6.933a1.229,1.229,0,0,1-1.233,1.229H13.709a1.228,1.228,0,0,1-1.229-1.229V17.188a1.228,1.228,0,0,1,1.229-1.229H16.02a1.229,1.229,0,0,1,1.233,1.229Zm9.518,7.355H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Zm0-2.248H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Zm0-4.769H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Zm0-2.248H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Z",
    transform: "translate(-9.847 -4.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.736,5.617h7.028a1.193,1.193,0,0,0,1.193-1.193V3.193A1.193,1.193,0,0,0,28.764,2H21.736a1.193,1.193,0,0,0-1.193,1.193v1.23A1.193,1.193,0,0,0,21.736,5.617Zm-.7,9.58-.826.562-.137-.233a.418.418,0,0,0-.721.424l.363.617a.418.418,0,0,0,.6.134l1.195-.812a.418.418,0,0,0-.47-.691Zm0,6.991-.826.562-.137-.233a.418.418,0,0,0-.721.424l.363.617a.418.418,0,0,0,.6.134l1.195-.812a.418.418,0,0,0-.47-.691Z",
    transform: "translate(-15.472 -2)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 17,
    height: 18,
    transform: "translate(18.71 299)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, 7.6, 293.66)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.458,14.132a1.168,1.168,0,0,0,1.169-1.169H7.289A1.168,1.168,0,0,0,8.458,14.132Zm4.871-2.767-.758-.758V7.082A4.109,4.109,0,0,0,9.34,3.069V2.381a.881.881,0,1,0-1.763,0v.687A4.109,4.109,0,0,0,4.346,7.082v3.525l-.758.758a.588.588,0,0,0,.411,1h8.913a.588.588,0,0,0,.417-1ZM9.046,10.019H7.871V8.844H9.046Zm0-2.938a.588.588,0,1,1-1.175,0V5.907a.588.588,0,1,1,1.175,0Z",
    transform: "translate(11.59 8.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup37001);
export default __webpack_public_path__ + "static/media/Group 3700(1).10c8e1d30c4b5e57d998764eae43cef3.svg";
export { ForwardRef as ReactComponent };